<p-confirmDialog
  key="indicatorDeleteDialog"
  #cd
  styleClass="w-9"
  appendTo="body"
  [blockScroll]="false">
  <ng-template pTemplate="headless" let-message>
    <div class="p-card border-round pt-1 p-4">
      <app-header
        icon="fas fa-trash"
        [text]="indicator.name + ' wirklich löschen?'"></app-header>

      @if (indicatorHasData) {
        <p appAlertStyle="warning" class="p-3">
          <i class="fas fa-exclamation-triangle"></i> Dabei werden auch alle
          Daten, die mit dem Indikator verknüpft sind, unwiderruflich gelöscht!
        </p>
        <p-divider></p-divider>
        <app-header icon="fas fa-database" text="Enthaltene Daten"></app-header>
        <p-scrollPanel styleClass="h-20rem">
          @if (indicator.isSet && indicatorChildren?.length) {
            @for (child of indicatorChildren; track child._id) {
              <app-header
                icon="fas fa-ruler-vertical"
                text="{{ child.name }}"></app-header>
              <app-indicator-data-list
                [disableImportButton]="true"
                [indicator]="child" />
            }
          } @else {
            <app-indicator-data-list
              [disableImportButton]="true"
              [indicator]="indicator" />
          }
        </p-scrollPanel>
      } @else {
        <app-alert [canToggle]="false" styleClass="p-3">
          <i class="fas fa-circle-info"></i> Diesem Indikator sind keine Daten
          zugeordnet. Er kann sicher gelöscht werden.
        </app-alert>
      }

      <p-divider></p-divider>
      <div class="flex align-items-center gap-3 mt-4">
        <button
          [rounded]="true"
          [outlined]="true"
          severity="secondary"
          pButton
          icon="fas fa-times"
          label="nein, abbrechen"
          (click)="cd.reject()"></button>
        <button
          [rounded]="true"
          pButton
          [severity]="'danger'"
          icon="fas fa-check"
          label="ja, löschen"
          (click)="cd.accept()"
          class="ml-auto"></button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
